import React from 'react';

function CustomRadio({ isChecked, id, name,isDisabled, onChange, value }: {isChecked?: boolean, id: string, name: string, isDisabled?:boolean,  onChange?(event: any): void, value: any }) {
  return (
    <div className="license-edit__checkbox">
      <input
        type="radio"
        name={name}
        id={id}
        checked={isChecked}
        onChange={onChange}
        value={value}
        disabled={isDisabled}
      />
      <div className="license-edit__checkbox-dot"></div>
    </div>
  );
}

export default CustomRadio;
